document.addEventListener('DOMContentLoaded', function() {
  // Function to open a modal
  function openModal(modalID) {
    const modalContainer = document.getElementById(modalID);
    if (modalContainer) {
      modalContainer.classList.add('active');
      modalContainer.classList.remove('hidden');
    }
  }

  // Function to close a modal
  function closeModal(modalContainer) {
    if (modalContainer) {
      modalContainer.classList.remove('active');
      modalContainer.classList.add('hidden');
    }

    // Yotpo adds css when loading widgets, so we need to remove it when the modal is closed
    const bodyElement = document.querySelector('body.template-page');
    if (bodyElement) {
      bodyElement.style.overflow = 'auto';
    }
  }

  // Open the modal when the reward tile is clicked
  document.querySelectorAll('.account-rewards-tile:not(#account-rewards-history)').forEach(tile => {
    tile.addEventListener('click', function() {
      const modalID = this.getAttribute('data-content-target-id');
      openModal(modalID);
    });
  });

  // Close the modal when the close button is clicked
  document.querySelectorAll('[data-modal-close-blacksmith]').forEach(button => {
    button.addEventListener('click', function(event) {
      event.preventDefault();
      const activeModal = document.querySelector('.modal.active');
      closeModal(activeModal);
    });
  });

  // Close the modal when the Escape key is pressed
  document.addEventListener('keydown', function(event) {
    if (event.keyCode === 27) { // 27 is the keyCode for the Escape key
      const activeModal = document.querySelector('.modal.active');
      closeModal(activeModal);
    }
  });

  // Workaround to get history information from modal
  const historyTile = document.getElementById('account-rewards-history');
  if (historyTile) {
    historyTile.addEventListener('click', async function() {
      const modalID = this.getAttribute('data-content-target-id');
      const historyContentElement = document.querySelector(`#${modalID} .yotpo-rewards-history-title.yotpo-rewards-history-title-text`);

      // If content is already loaded, open the modal
      if (historyContentElement) {
        openModal(modalID); 
        return;
      }
    
      // Function to click the history button and get the content
      const tryClickHistoryButton = async () => {
        const historyTargetButton = document.querySelector(`#${modalID} .yotpo-action-button.yotpo-secondary-button button`);
        
        if (historyTargetButton) {
          await historyTargetButton.click();
          const historyContent = document.querySelector(`#${modalID} .yotpo-rewards-history-wrapper`).outerHTML;
          
          // Wrap the historyContent in a new div with the proper yotpo classes
          const wrapperHistory = document.createElement('div');
          wrapperHistory.classList.add('yotpo-widget-my-rewards-widget', 'yotpo-widget-override-css');
          wrapperHistory.innerHTML = historyContent;
          
          // Set the innerHTML of the modal to the historyContent
          const modalContent = document.querySelector(`#${modalID} .modal__content-blacksmith`);
          if (modalContent) {
            modalContent.innerHTML = wrapperHistory.outerHTML;
            openModal(modalID);
          }
        } else {
          setTimeout(tryClickHistoryButton, 100);
        }
      };
    
      tryClickHistoryButton();
    });
  }
});